import { Grid, Tooltip, IconButton } from "@mui/material"
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs from "dayjs"
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useContext } from "react";
import CurrentUserContext from "@/Contexts/CurrentUser";
import { combinedFormat } from "@/utils/helperFunctions";

interface ReminderSectionProps {
  reminderValue: dayjs.Dayjs | null
  setReminder: (timeStamp: string) => void
  resetReminder: () => void
}

const ReminderSection: React.FC<ReminderSectionProps> = ({ setReminder, reminderValue, resetReminder }) => {
  const { dateTimePreference } = useContext(CurrentUserContext);

  return (
    <Grid container alignItems='center' mb={1} size={12}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          format={combinedFormat(dateTimePreference)}
          label="set reminder (optional)"
          value={reminderValue}
          onChange={(newValue) => {
            if (newValue && !newValue.isValid()) return
            setReminder(newValue ? newValue.toISOString() : "")
          }
          }
          slotProps={{
            textField: {
              required: false,
            },
          }}
        />
      </LocalizationProvider>
      {reminderValue &&
        <Tooltip title="Reset reminder">
          <IconButton
            onClick={resetReminder}
          >
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
      }
    </Grid>
  );
}

export default ReminderSection
